// HTTP Methods
export const HTTP_METHOD_GET = 'GET';

// API Endpoints
export const ENDPOINT_GET_ACCESS_MODULES = '/api/usersPublic/getaccessmodulesbyemail';

// LocalStorage Keys
export const STORAGE_KEY = {
    USER_DATA: 'userData',
    USER_MODULES: 'userModules',
    USER_GROUPS: 'userGroups',
    USER_IS_ADMIN: 'userIsAdmin'
};

// Default Values
export const DEFAULT_EMPTY_ARRAY_JSON = '[]';
export const DEFAULT_FALSE_JSON = 'false';
export const EMPTY_STRING = '';

// Array Index
export const FIRST_ACCOUNT_INDEX = 0;

// Module Names
export const MODULE_NAMES = {
    HOME_PAGE: 'HomePage',
    SALES_PROMOTIONS_PAGE: 'SalesPromotionsPage',
    PERMISSIONS_PAGE: 'PermissionsPage',
    APROVE_LINES_PAGE: 'AproveLinesPage',
    OBLIGO_EXCEPTION_PAGE: 'ObligoExceptionPage',
    VIEW_OBLIGO_DATA: 'ViewObligoData',
    CHECK_INVOICES_PAGE: 'CheckInvoicesPage',
    PURCHASE_INVOICE_PAGE: 'PurchaseInvoicePage',
    FORM161_PAGE: 'Form161Page',
    ADMIN: 'admin',
    TIME_LINE_PAGE: 'TimeLinePage',
    ELDAN_PRINTER_PAGE: 'EldanPrinterPage',
    CHEMO_RECORDS_PAGE: 'ChemoRecordsPage',
    IMPORT_MANAGEMENT_PAGE: 'ImportManagementPage',
    EMAIL_TRACKING_PAGE: 'emailTrackingPage',
    RESEARCH_MONITOR_PAGE: 'ResearchMonitorPage',
    QR_CODE_DEVICE_MAPPING_PAGE: 'QrCodeDeviceMappingPage',
    TRADE_DELAY_PAGE: 'TradeDelayPage',
    FUEL_CONTROL_PAGE: 'FuelControlPage',
    HRCV_MATCHING_PAGE: 'HRCVMatchingPage',
    PROMOTIONS_SYSTEM_PAGE: 'PromotionsSystemPage',
    DPL_STATISTICS_PAGE: 'DplStatisticsPage',
    ELDAN_AGENT_PAGE: 'EldanAgentPage',
    LIBERTY_MEDICAL_PAGE: 'LibertyMedicalPage',
    MANAGERS_DASHBOARD_PAGE: 'ManagersDashboardPage',
    PURCHASE_ORDER_MANAGEMENT_PAGE: 'PurchaseOrderManagementPage',
    BDI_MONITORING_PAGE: 'bdiMonitoringPage',
    SAL_COMMITTEE_PAGE: 'SalCommitteePage',
    SAL_PRESENTATION_PAGE: 'SalPresentationPage',
    PACKAGING_CHECK_PAGE: 'PackagingCheckPage',
};

// User Object Fields
export const USER_FIELDS = {
    ID: '_id',
    ACCESS_RIGHTS: 'accessRights',
    ROLES: 'roles',
    USER_BRANCHES_LIST: 'userBranchesList',
    FULL_NAME: 'fullName',
    EMAIL: 'email',
    PRIORITY_USER_NAME: 'priorityUserName',
    HOSPITAL: 'hospital',
    GROUPS: 'groups',
    IS_ADMIN: 'isAdmin',
    MODULES: 'modules',
    TRADE_DELAY_ROLE: 'tradeDelayRole'
};

// Token Claims
export const TOKEN_CLAIMS = {
    GROUPS: 'groups'
};

// Special Characters
export const GROUP_ID_SEPARATOR = '-';
